import turf_bbox from '@turf/bbox';
import { lineString as turf_lineString } from '@turf/helpers';

interface LocationLngLat {
  lng_lat: [number, number];
}

export function getBounds(
  locations: LocationLngLat[]
): [[number, number], [number, number]] {
  const filteredLocations = locations.filter(
    (location: LocationLngLat) =>
      location.lng_lat &&
      location.lng_lat.length === 2 &&
      typeof location.lng_lat[0] === 'number' &&
      typeof location.lng_lat[1] === 'number'
  );
  let bbox: number[];

  if (filteredLocations.length > 1) {
    const line = turf_lineString(filteredLocations.map((d) => d.lng_lat));
    bbox = turf_bbox(line);
  } else if (filteredLocations.length === 1) {
    bbox = [...filteredLocations[0].lng_lat, ...filteredLocations[0].lng_lat];
  } else {
    bbox = [0, 0, 0, 0];
  }

  // handle special case where it's just one point by extending the box epsilon amount
  if (bbox[0] === bbox[2] && bbox[1] === bbox[3]) {
    const epsilon = 0.01;
    bbox[0] -= epsilon;
    bbox[1] -= epsilon;
    bbox[2] += epsilon;
    bbox[3] += epsilon;
  }

  return [
    [bbox[0], bbox[1]],
    [bbox[2], bbox[3]],
  ];
}
